import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { DatasetDetailsImagesView } from '../../views/home/datasetsDetails/DatasetDetailsImages.view';
import { DatasetDetailsProjectsView } from '../../views/home/datasetsDetails/DatasetDetailsProjects.view';
import { Home } from '../config/Home';

export const DatasetDetailsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Datasets.Details.Images.Path}>
      <DatasetDetailsImagesView />
    </Route>
    <Route path={Home.Datasets.Details.Projects.Path}>
      <DatasetDetailsProjectsView />
    </Route>
  </SwitchWithNotFound>
);
